import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { isTargetInsideContainer } from '../../utils/DomUtils.js';
import { getNamedNavigationTree } from '../../utils/NavigationUtils.js';
import { getInitialViewportSize, addViewportCallback, removeViewportCallback } from '../../utils/windowEvents/ResizeEvents.js';
import { PortalHeaderPresentation } from './PortalHeaderPresentation.js';

var findPathRecursive = function findPathRecursive(navigationTree, value) {
  var item = navigationTree.find(function (i) {
    return i.name === value;
  });

  if (item) {
    return [item];
  }

  return navigationTree.map(function (i) {
    if (i.children) {
      var childResult = findPathRecursive(i.children, value);

      if (childResult) {
        return [i].concat(childResult);
      }
    }

    return undefined;
  }).find(function (i) {
    return !!i;
  });
};

var findPath = function findPath(navigationTree, value) {
  if (value === undefined) {
    return;
  }

  return findPathRecursive(navigationTree, value) || [];
};

var PortalHeaderWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(PortalHeaderWrapper, _React$Component);

  var _super = _createSuper(PortalHeaderWrapper);

  function PortalHeaderWrapper(props) {
    var _this;

    _classCallCheck(this, PortalHeaderWrapper);

    _this = _super.call(this, props);

    _this.onViewportChange = function (viewport) {
      return _this.setState({
        isMobile: ["md", "sm", "xs"].includes(viewport)
      });
    };

    _this.state = {
      counter: 0,
      selectedPath: [],
      noAnimation: false,
      forceMobile: false,
      isMobile: ["md", "sm", "xs"].includes(getInitialViewportSize())
    };
    return _this;
  }

  _createClass(PortalHeaderWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      addViewportCallback(this.onViewportChange);
      this.setState(function (prevState) {
        return {
          counter: prevState.counter + 1
        };
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeViewportCallback(this.onViewportChange);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.value !== this.props.value) {
        var namedNavigationTree = getNamedNavigationTree(this.props.navigationTree);
        var selectedPath = findPath(namedNavigationTree, this.props.value); // render twice to update indicator

        this.setState(function (p) {
          return {
            selectedPath: selectedPath,
            openValue: undefined,
            counter: p.counter + 1,
            noAnimation: false
          };
        });
      }

      if (prevState.selectedPath !== this.state.selectedPath || prevState.openValue !== this.state.openValue || prevState.isMobile !== this.state.isMobile) {
        // render twice to update indicator
        this.setState(function (p) {
          return {
            counter: p.counter + 1,
            noAnimation: true
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          selectedPath = _this$state.selectedPath,
          openValue = _this$state.openValue,
          noAnimation = _this$state.noAnimation,
          isMobile = _this$state.isMobile,
          forceMobile = _this$state.forceMobile,
          scrollPosition = _this$state.scrollPosition;
      var namedNavigationTree = getNamedNavigationTree(this.props.navigationTree);
      return /*#__PURE__*/React.createElement(PortalHeaderPresentation, Object.assign({}, this.props, {
        navigationTree: namedNavigationTree,
        activeRef: function activeRef(r) {
          return _this2.activeElement = r;
        },
        activeElement: this.activeElement,
        activeSubmenuRef: function activeSubmenuRef(r) {
          return _this2.activeSubmenuElement = r;
        },
        activeSubmenuElement: this.activeSubmenuElement,
        activeMobileRef: function activeMobileRef(r) {
          return _this2.activeMobileElement = r;
        },
        activeMobileElement: this.activeMobileElement,
        activeMobileSubmenuRef: function activeMobileSubmenuRef(r) {
          return _this2.activeMobileSubmenuElement = r;
        },
        activeMobileSubmenuElement: this.activeMobileSubmenuElement,
        navigationBarRef: function navigationBarRef(r) {
          return _this2.navigationBarElement = r;
        },
        mobileMenuLinkRef: function mobileMenuLinkRef(r) {
          return _this2.mobileMenuLinkElement = r;
        },
        selectedPath: selectedPath,
        openPath: findPath(namedNavigationTree, openValue),
        onOpenChange: function onOpenChange(newOpen) {
          return _this2.setState(function (prevState) {
            return {
              openValue: newOpen === prevState.openValue ? undefined : newOpen
            };
          });
        },
        onHeaderClick: function onHeaderClick(e) {
          if (!isTargetInsideContainer(e.target, _this2.navigationBarElement) && !isTargetInsideContainer(e.target, _this2.mobileMenuLinkElement)) {
            _this2.setState({
              openValue: undefined
            });
          }
        },
        noAnimation: noAnimation,
        isMobile: forceMobile || isMobile,
        setScrollPosition: function setScrollPosition(scrollPosition) {
          return _this2.setState({
            scrollPosition: scrollPosition
          });
        },
        scrollPosition: scrollPosition,
        onForceMobileChange: function onForceMobileChange(forceMobileValue) {
          return _this2.setState({
            forceMobile: forceMobileValue
          });
        }
      }));
    }
  }]);

  return PortalHeaderWrapper;
}(React.Component);

export { PortalHeaderWrapper };
